/**
 * @file: estimateFinishTimeUtil.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { dateFromValue } from '@euler/utils/datetime';

export const estimatedFinishTimeValue = (
  x: string | Date | null | undefined,
) => (x == null ? undefined : dateFromValue(x));

export const requireReasonForEstimatedFinishTimeChange = (
  curr: Date | undefined,
  prev: Date | undefined,
) => {
  if (prev == null) return false;
  if (curr == null) return true;
  return curr.getTime() !== prev.getTime();
};
